<div class="h-100" #pdfViewContainer>
  <div class="h-100 d-flex flex-wrap-reverse">

    @if (adminDoc) {
      <div class="info-section">
        <app-metadata
          [documentType]="'admin_doc'"
          [website]="adminDoc.website"
          [publicationDate]="adminDoc.publicationDate"
          [territories]="adminDoc.territories"
          [issuerKind]="adminDoc.source"
          [displayedPublicationType]="adminDoc.displayedPublicationType">
        </app-metadata>

        <app-welcome-panel [shareToken]="shareToken" class="pt-2"></app-welcome-panel>
      </div>
    }

    @if (adminDoc) {
      <div class="right-content position-relative">
        <div class="shadow-overlay">
          <div class="first-line w-100 position-relative"></div>
        </div>
        <app-admin-doc-pdf [adminDoc]="adminDoc"
                           [pdfView]="pdfView"
                           [time]="time"
                           [guestView]="true"></app-admin-doc-pdf>
      </div>
    }
  </div>
</div>
